import CONSTANT from '../../constants'
import fetchWithAuthorizationHeader from '../../helper/fetchWithAuthorizationHeader'

const { CLUSTERS_API_URL } = CONSTANT

const getSingleCluster = async (
	clusterID: string
): Promise<{ status: number; body: object | Array<object> }> => {
	const response = await fetchWithAuthorizationHeader(
		`${CLUSTERS_API_URL}?clusterID=${clusterID}`
	)
	return response.json()
}

export default getSingleCluster
